import Container from 'components/ui/Container';
import CustomSelect from 'components/ui/Editor/CustomSelect';
import EditorComponent from 'components/ui/Editor/editor';
import { FileDrop } from 'components/ui/FileDrop/FileDrop';
import FormikValidationError from 'components/ui/FormikErrors';
import PrimaryButton from 'components/ui/PrimaryButton';
import SecondaryButton from 'components/ui/SecondaryButton';
import Spinner from 'components/ui/Spinner/spinner';
import TextInput from 'components/ui/TextInput';
import { useFormik } from 'formik';
import React, { FC, useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CoursesResponse, ICoursesInput, useListCoursesQuery } from 'redux/reducers/courses';
import {
  IOrganizationCentreInput,
  useListOrganizationCentreQuery
} from 'redux/reducers/organizations-centre';
import {
  ITrainingInput,
  useCreateTrainingMutation,
  useListTrainingByIdQuery,
  useUpdateTrainingMutation
} from 'redux/reducers/training';
import { useListTrainingTypeQuery } from 'redux/reducers/training-type';
import { boolean } from 'yup';

import { trainingInitialValues, TrainingSchemaValidations } from './schema';
import getDoaminName from 'lib/getDomainName';
import { backendURL, nascsubdomain, trainingsubdomain } from 'redux/reducers/settings';
import { ConfigurationContext } from 'components/provider/OrginazationContext';
import { useGetAllActiveCourseList } from 'service/admin.query';

interface ITrainingForm {}
const TrainingForm: FC<ITrainingForm> = () => {
  let { trainingId } = useParams();
  const navigate = useNavigate();

  const { data: courseList } = useGetAllActiveCourseList();

  const [createTraining, { isLoading: isCreating }] = useCreateTrainingMutation();
  const [updateTraining, { isLoading: isUpdating }] = useUpdateTrainingMutation();
  const [trainingInitialFormState, setTrainingInitialForm] = useState(trainingInitialValues);
  const isCreate = trainingId === 'create';
  const { data: trainingById, isLoading: isFetchingTrainingDetail } = useListTrainingByIdQuery(
    trainingId ? trainingId : '',
    { skip: isCreate || !trainingId }
  );



  // React.useEffect(() => {
  //   if (trainingById && !isFetchingTrainingDetail) {
  //     setTrainingInitialForm({
  //       ...trainingById.data,
  //       training_code: trainingById.data.training_code,
  //       training_description: trainingById.data.training_description,
  //       training_name: trainingById.data.training_name,
  //       courses: trainingById?.data?.courses?.map((item: any) => item.id.toString()),
  //       image: []
  //     });
  //   }
  // }, [trainingById, isFetchingTrainingDetail, courseList]);
  React.useEffect(() => {
    if (trainingById?.data && !isFetchingTrainingDetail) {
      const t = trainingById.data;
      setTrainingInitialForm({
        ...trainingInitialValues,
        ...t,
        courses: t.courses?.map((c: any) => c.id.toString()) ?? [],
        image: []
      });
    }
  }, [trainingById, isFetchingTrainingDetail]);

  const courseListsOptions =
    courseList?.map((item: CoursesResponse) => ({
      label: item.title,
      value: item.id.toString()
    })) ?? [];

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: TrainingSchemaValidations,
    initialValues: trainingInitialFormState,
    onSubmit: (values) => {
      if (values?.image[0]?.size > 1048576) {
      } else {
        let executeFunc = createTraining;
        if (trainingId) {
          executeFunc = updateTraining;
        }
        const img = values.image?.[0] || [];
        let selectedValues = {
          ...values,
          id: trainingId,
          courses: values.courses.map((c) => +c),
          // image: new Blob([img],{type:img.type})
          image: img,
          is_active:values.is_active
        };
        // if(values.image.length) {
        //   let data = new FormData();
        //   values.image.map((image,i) => {
        //     data.append(`img${i+1}`)
        //   })
        // }

        const { ...trainingValues } = selectedValues;

        executeFunc(trainingValues)
          .unwrap()
          .then(() => {
            toast.success('Updated Successfully');
            setTrainingInitialForm(trainingInitialValues);
            navigate('/training-mgmt/training');
          })
          .catch(() => {
            toast.error('Error');
          });
      }
    }
  });

  const siteName = getDoaminName();
  const { appConfig } = useContext(ConfigurationContext);

  return (
    <Container title={trainingInitialFormState.id ? 'Update Training' : 'Create Training'}>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-4">
            {siteName == nascsubdomain ? (
              <img
                src={backendURL + appConfig?.logo}
                alt=""
                style={{ height: 200, width: 200, borderRadius: '50%' }}
              />
            ) : (
              <FileDrop
                defaultImage={trainingById?.data?.image ?? ''}
                files={formik.values.image}
                setFiles={(data) => {
                  if (data[0].size > 1048576) {
                  }
                  formik.setFieldValue('image', data);
                }}
                preview={true}
                message={'Click to upload the logo'}
              />
            )}
            <FormikValidationError name="image" errors={formik.errors} touched={formik.touched} />
          </div>

          <div className="col-8">
            <div className="row">
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <TextInput
                  containerClassName="mt-3 col-lg-6 col-md-6"
                  label="Training Name"
                  name="training_name"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.training_name}
                  onBlur={formik.handleBlur}
                  formik={formik}
                  disableRequiredValidation
                />
                <TextInput
                  containerClassName="mt-3 col-lg-6 col-md-6"
                  label="Training Code"
                  name="training_code"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.training_code}
                  onBlur={formik.handleBlur}
                  formik={formik}
                  disableRequiredValidation
                />
              </div>

              <CustomSelect
                containerClassName="mt-3 col-lg-12 col-md-6 col-sm-12"
                options={courseListsOptions}
                placeholder={'Search by title'}
                value={formik.values.courses}
                onChange={(value: string) => formik.setFieldValue('courses', value)}
                isMulti={true}
                label={'Course'}
              />
              <FormikValidationError
                name="courses"
                errors={formik.errors}
                touched={formik.touched}
              />

              <div className="my-3 col-md-12">
                <EditorComponent
                  label="Training Description"
                  containerClassName="mt-3"
                  editorValue={formik.values.training_description}
                  onChangeValue={(data) => formik.setFieldValue('training_description', data)}
                />
              </div>
              <FormikValidationError
                name="training_description"
                errors={formik.errors}
                touched={formik.touched}
              />
            </div>
            <div className="col-12 mb-3 mt-4 d-flex align-items-end">
                  <div className="form-check form-switch form-switch-md mb-3">
                    <label className="form-check-label" htmlFor="customSwitchsizesm">
                       Display
                    </label>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="customSwitchsizesm"
                      checked={formik.values.is_active}
                      onChange={(e) => {
                        formik.setFieldValue('is_active', !formik.values.is_active);
                      }}
                    />
                  </div>
                </div>
          </div>
        </div>

        <div className="hstack gap-2 justify-content-end">
          <SecondaryButton
            onClick={() => navigate('/training-mgmt/training')}
            title="Close"
            isLoading={isUpdating || isCreating}
          />
          <PrimaryButton
            title={trainingInitialFormState.id ? 'Update Training' : 'Create Training'}
            iconName={`${trainingInitialFormState.id ? '' : 'ri-add-line'} align-bottom me-1`}
            type="submit"
            isLoading={isUpdating || isCreating}
          />
        </div>
      </form>
    </Container>
  );
};

export default TrainingForm;
